// components
import { GridCompact12 } from 'components/shared/Grid/Grid.components';
import { ControlledTextField } from 'components/shared/ControlledFields';
import SectionHeader from '../SectionHeader/SectionHeader';
import { Icon } from '@sdb/planning-ui';

// hooks
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// types
import { AppointmentFormFieldData } from '../../AppointmentForm.types';
import { SpacedBox } from '../../AppointmentForm.styles';

const CommentSection = () => {
  'use memo';
  const { t } = useTranslation('common', { keyPrefix: 'mrp.appointmentForm' });
  const { control } = useFormContext<AppointmentFormFieldData>();

  return (
    <GridCompact12>
      <SectionHeader
        label={t('notes')}
        icon={<Icon type="comment" fontSize="inherit" />}
      />
      <SpacedBox>
        <ControlledTextField
          multiline
          minRows={3}
          control={control}
          name="notePublic"
          label={t('notePublic')}
          maxRows={10}
        />
      </SpacedBox>
      <SpacedBox>
        <ControlledTextField
          multiline
          minRows={3}
          control={control}
          name="noteInternal"
          label={t('noteInternal')}
          maxRows={10}
        />
      </SpacedBox>
    </GridCompact12>
  );
};

export default CommentSection;
